const ObjectMaintenance = {

    // FIELDS
    "equipment_condition": "Equipment Condition",
    "assign_to": "Assign To",
    "notes": "Notes",
    "basic_details": "Basic Details",

    // PAGE HEADER
    "create_object_maintenance": "Create Object Maintenance",
    "object_maintenance_created": "Object Maintenance Created",

    // ERROR
    "error_object_condition": "Select Equipment Condition",
    "error_assign_to": "Select Staff to Assign",
    "error_notes": "Enter Notes",

}

export default ObjectMaintenance;